// extracted by mini-css-extract-plugin
export default {"not-found":"Error_not-found__uArlZ","not-found--message":"Error_not-found--message__KJhZ4","btn--back":"Error_btn--back__M+KtC"};